export const CATEGORY_IMAGES = {
  "flower-strains": "/categories/flower-strains.webp",
  "pre-rolls": "/categories/pre-rolls.webp",
  "edibles": "/categories/edibles.webp",
  "disposables-carts": "/categories/disposables-carts.webp",
  "concentrates": "/categories/concentrates.webp",
  "cartridges": "/categories/cartridges.webp",
  "shatter": "/categories/shatter.webp",
  "special-deals": "/categories/special-deals.webp",
};
